// ----------------------------------------------------------------------

export const _socials = [
  {
    value: 'facebook',
    name: 'Facebook',
    path: 'https://www.facebook.com/caitlyn.kerluke',
  },
  {
    value: 'instagram',
    name: 'Instagram',
    path: 'https://www.instagram.com/caitlyn.kerluke',
  },
  {
    value: 'linkedin',
    name: 'Linkedin',
    path: 'https://www.linkedin.com/caitlyn.kerluke',
  },
  {
    value: 'twitter',
    name: 'Twitter',
    path: 'https://www.twitter.com/caitlyn.kerluke',
  },
];

// ----------------------------------------------------------------------

export const lISTENER_OPTIONS = [
  { value: 'static', label: 'Static Text', key: 1 },
  // { value: 'ai', label: 'AI', key: 2 },
];

export const KEYWORD_CONDITIONS = [
  { value: 'contains', label: 'Contains', key: 1 },
  { value: 'regex', label: 'Starts with', key: 2 },
  { value: 'equals', label: 'Exact match', key: 3 },
];

export const POSTS_OPTIONS = [
  { value: '1', label: 'Post N.1' },
  { value: '2', label: 'Post N.2' },
];

export const KEYS_OPTIONS = [
  // 'Every',
];